import { BaseClientService, Error, Result } from "../BaseClientService";
import { Member } from "interfaces/front/business";

export class FrontMeService extends BaseClientService {
  url: string;

  constructor() {
    super();
    this.url = this.API_BASE_URL + "/api/front/me";
  }

  async me(): Promise<Result<Member, Error>> {
    return super.doGet<Member, Error>(this.url, "");
  }
}
